import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import clsx from "clsx";
import styles from "./style/QuizItem.module.css";
import { ConfirmModal } from "@components/ConfirmModal";
import { CurriculumContext } from "@pages/EditingCoursePage/CurriculumTab";
import { QuizFormModal } from "@components/QuizFormModal";

const QuizItem = ({ quizData, sectionId }) => {
  // state

  // variables

  // logics before hooks

  // hooks
  const { handleDeleteQuiz, handleEditQuiz } = useContext(CurriculumContext);
  // logics

  // UI partials

  // effects

  // render

  return (
    <div
      className={clsx(
        styles.container,
        "py-2 px-3",
        quizData.isDeleted ? "d-none" : null
      )}
    >
      <div className="d-flex align-items-center">
        <i className="bi bi-lightbulb-fill"></i>

        <span className={clsx("mx-2", styles.title)}>{quizData.title}</span>
        {/* {addLectureProcessing?.processing ||
        updateLectureProcessing?.processing ? (
          <Spinner animation="border" size="sm" variant="danger" />
        ) : null} */}
        <QuizFormModal
          onSubmit={(newQuiz) => handleEditQuiz(sectionId, newQuiz)}
          initialValues={quizData}
          submitText="Save"
        >
          <button className="ml-2 opacity-0">
            <i className="bi bi-pencil-square"></i>
          </button>
        </QuizFormModal>
        {/* <DeleteLectureModal onDelete={onDelete}> */}
        <ConfirmModal
          onSubmit={() => handleDeleteQuiz(sectionId, quizData.id)}
          title={"Delete Quiz"}
          body={"Do you really want to delete this quiz?"}
          submitButton={"Delete"}
        >
          <button type="button" className="ml-2 opacity-0">
            <i className="bi bi-trash-fill"></i>
          </button>
        </ConfirmModal>
        {/* </DeleteLectureModal> */}
      </div>
      <div>
        <button className="opacity-0">
          <i className="bi bi-list"></i>
        </button>
      </div>
    </div>
  );
};

/* required: display name */
QuizItem.displayName = "QuizItem";

/* required: props types */
QuizItem.propTypes = {};

/* required: default props */
QuizItem.defaultProps = {};

export { QuizItem };
